/**
 *
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2016 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        http://www.sudimage.fr
 */

var size = 100;

function setCookie() {
  var d = new Date();
  d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = "sudimageSetFontSize=" + size + "; " + expires + "; path=/";
}
function getCookie() {
  var name = "sudimageSetFontSize=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setFontSize(action) {
  var $body = $('body');
  switch (action) {
    case 'plus':
      size = size + 20;
      setCookie();
      break;
    case 'minus':
      size = size - 20;
      setCookie();
      break;
    case 'reload':
      size = size;
      break;
    case 'normal':
      size = 100;
      document.cookie = "sudimageSetFontSize=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  }
  $body.css({fontSize: size + '%'});
}
$('img[data-action-font-size]').on('click', function (e) {
  e.preventDefault();
  setFontSize($(this).attr('data-action-font-size'));
});
$(document).ready(function () {
  var fontSize = getCookie();
  if (fontSize !== "") {
    size = fontSize;
    setFontSize('reload');
  }
  $('[data-toggle="tooltip"]').tooltip();
});